export default {
  setFeedList(state, payload) {
    state.feedList = payload;
  },
  setFeedCategory(state, payload) {
    state.feedCategory = payload;
  },
  setHierarchicMainCatId(state, payload) {

    const isHierarchic = payload.isHierarchic;
    const opcommentid = payload.opCommentId;

    state.hierarchicMainCatId = opcommentid;
    const feed = state.feedList.find(x => x.id == payload.feedId);

    if (feed) {
      feed.opcommentid = opcommentid;

      if(isHierarchic){
        const subCatList = state.feedCategory.subCategory;
        feed.subCatOptions = subCatList;
      }
    }
  },
  setHierarchicSubCatId(state, payload) {
    const isHierarchic = payload.isHierarchic;
    const opstatusid = payload.opStatusId;

    state.hierarchicSubCatId = opstatusid;
    const feed = state.feedList.find(x => x.id == payload.feedId);

    if (feed) {
      feed.opstatusid = opstatusid;
      if(isHierarchic){
        const detailCatList = state.feedCategory.detailCategory;
        feed.detailCatOptions = detailCatList;
      }
    }
  },
  setHierarchicDetailCatId(state, payload) {
    const opTypeId = payload.opTypeId;
    const feed = state.feedList.find(x => x.id == payload.feedId);
    if (feed) {
      feed.optypeid = opTypeId;
    }
  }
};